import WhiteButton from "./white-button"

export default WhiteButton
